import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseResourceAvailabilityService {
  abstract isCaseInCurrentAgency(): Observable<boolean>;
  abstract isEvidenceInCurrentAgency(): Observable<boolean>;
  abstract isOfficerOrMemberInCurrentAgency(uid: string): Observable<boolean>;
}
